export const factoryServices = `query serviceAvailability($filter: ServiceAvailabilityRequest!) {
  serviceAvailability(filter: $filter) {
    services {
      pkId
      version
      region
      businessGroup
      productGroup
      productFamily
      productDesc
      country
      businessModel
      material
      startDate
      endDate
      materialDesc
      choiceId
      comments
      status
      wwAutoStartDate
      wwAutoEndDate
      countryDesc
      apRegion
      euRegion
      naRegion
      laRegion
      whoChanged
      regionLock
      logicalLock
      lastModifiedDate
      createDate
      keyOrder
    }
  }
}`;

 
 
